export default "__VITE_ASSET__WzIiCDYf__"